import { getInFilterValue } from '../utils';
import { BaseHelper } from './BaseGraphQLAPIHelper';

// const MALL_NODE = `
// id
// pk
// name
// icon
// photo
// photoUrl
// district {
//   region {
//       pk
//       name
//   }
//   name
// }
// address
// latitude
// longitude
// visibleInFrontEnd
// thirdPartyMallCode
// translations {
//   edges {
//     node {
//       language
//       name
//       address
//     }
//   }
// }
// `

// const SIMPLE_MALL_NODE = `
// id
// pk
// name
// `

// const LIST_NODE = `
// id
// pk
// name
// photo
// photoUrl
// visibleInFrontEnd
// lastModifiedDate
// `

const MALL_NODE = `
id
pk
name
thirdPartyMallCode
`;

const SIMPLE_MALL_NODE = `
id
pk
name
`;

const LIST_NODE = `
id
pk
name
lastModifiedDate
`;

export const getMalls = () => {
  const query = `{
        malls(first: 100, orderBy: "-pk") {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              ${SIMPLE_MALL_NODE}
            }
          }
        }
      }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getPagedMalls = (afterCursor, search = {}) => {
  // const order = rank ? '-pk' : 'pk';
  console.log('@@73: ', search);
  let searchString = '';
  if (search.search) {
    searchString += `, name: "${search.search}"`;
  }

  if (search?.visible_in_front_end !== undefined) {
    searchString += `, visibleInFrontEnd: ${search.visible_in_front_end}`;
  }

  let orderBy = '-pk';
  if (search?.sort) {
    orderBy = search.sort;
  }
  let pageSize = 20;
  if (search?.pageSize) {
    pageSize = search.pageSize;
  }
  const mallNode = search?.isListNode
    ? LIST_NODE
    : search?.isSimpleNode
    ? SIMPLE_MALL_NODE
    : MALL_NODE;
  const query = `{
    malls(first: ${pageSize}, after: "${afterCursor}", orderBy: "${orderBy}"${searchString}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ${mallNode}
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getOneMall = (id) => {
  const query = `{
    mall(id: "${id}") {
      ${MALL_NODE}
    }
  }
  `;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteMalls = (ids) => {
  const query = `mutation DeleteMalls($input: DeleteMallsInput!) {
    deleteMalls(input: $input) {
      success
    }
  }
  `;
  const variables = { input: { ids: ids } };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createOrUpdateMall = (values) => {
  const action = values.id ? 'Update' : 'Create';
  let query = `mutation ${action}Mall($input: ${action}MallInput!) {
    ${action.toLowerCase()}Mall(input: $input) {
      success
      node {
        ${MALL_NODE}
      }
      errors {
        field
        messages
      }
    }
  }

  `;

  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};
